import React, { useContext } from "react";
import DrawCanvas from "./DrawCanvas";
import SharedDrawHost from "./SharedDrawHost";
import useDrawHost from "./useDrawHost";

/**
 * Board widget for a draw-mode question: shows the session QR until the
 * drawer starts, then mirrors the drawing live. If the realtime server can't
 * be reached it falls back to the baked QR image, which still gives the
 * drawer the word. When the intro screen already opened the session, this
 * mirrors that one instead of opening its own.
 */
const DrawBoard = ({ qrCodeId, fallbackImage, alt }) => {
  const sharedHost = useContext(SharedDrawHost);
  const ownHost = useDrawHost(sharedHost ? null : qrCodeId);
  const { phase, qrDataUrl, store, drawerConnected } = sharedHost || ownHost;

  if (phase === "error") {
    return fallbackImage ? (
      <img className="h-full object-contain" src={fallbackImage} alt={alt} />
    ) : null;
  }

  if (phase === "drawing") {
    return (
      <div className="relative h-full w-full">
        <DrawCanvas store={store} readOnly className="h-full w-full" />
        {!drawerConnected && (
          <div
            dir="rtl"
            className="absolute bottom-2 left-1/2 -translate-x-1/2 bg-black bg-opacity-70 text-white text-sm font-bold px-4 py-1 rounded-full"
          >
            انقطع اتصال الرسام...
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="h-full w-full flex flex-col items-center justify-center gap-2">
      {qrDataUrl ? (
        <img
          className="min-h-0 flex-1 object-contain rounded-lg"
          src={qrDataUrl}
          alt={alt}
        />
      ) : (
        <div className="flex-1" />
      )}
      <p dir="rtl" className="text-white text-lg md:text-2xl font-bold">
        {qrDataUrl ? "امسح الرمز وابدأ الرسم" : "جاري التحميل..."}
      </p>
    </div>
  );
};

export default DrawBoard;
